import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import {
  useViewContext,
  resolveViewFromPathname,
} from "@/app/stores/viewContext"

/**
 * Sync the URL / router state → ViewContext store.
 *
 * Placed once in AppLayout (Tier 1 in hook orchestration).
 * Reactive — runs on every route change via useLocation.
 *
 * NOTE: We extract containerId from the pathname string (not useParams)
 * because AppLayout renders ABOVE the <Route> definitions, so
 * useParams() would always return {} at this level.
 */
export function useViewContextSync() {
  const { pathname } = useLocation()
  const setView = useViewContext((s) => s.setView)

  useEffect(() => {
    const { viewId, containerId } = resolveViewFromPathname(pathname)
    setView(viewId, containerId)
  }, [pathname, setView])
}
